import { render, staticRenderFns } from "./SettlementSiteTab.vue?vue&type=template&id=55bd1fe0"
import script from "./SettlementSiteTab.vue?vue&type=script&lang=js"
export * from "./SettlementSiteTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports